// Lib
import * as Immutable from 'immutable';

// Constants
import { LOCALE_SUGGESTION_SHOWN } from './localeSuggestionConstants';

const initialState = Immutable.Map({
    alreadySuggestedThisSession: false,
});

export default (state = initialState, action: any) => {
    switch (action.type) {
        case LOCALE_SUGGESTION_SHOWN:
            return state.set('alreadySuggestedThisSession', true);
        default:
            return state;
    }
};
